// extracted by mini-css-extract-plugin
export default {"imgBadge":"common_imgBadge__XELBL","name":"common_name__T4KEz"};